var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgILogoSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 15.93c0 8.997-6.106 15.273-15 15.273-8.895 0-15-6.276-15-15.274 0-1.436.15-2.722.452-4.007.075-.151.302-.227.452-.151l4.146 2.268c1.357.832 1.583 1.89 1.658 2.647.227 5.292 3.618 8.921 8.367 8.921 4.975 0 8.442-3.856 8.442-9.526 0-5.595-3.542-9.527-8.442-9.527-3.316 0-5.955 1.739-7.311 4.612 0 .076-.151.151-.226.151H1.13c-.227 0-.377-.227-.302-.378C2.713 4.815 7.989.883 15.075.883c8.82 0 15 6.2 14.925 15.046z",
    fill: "#FFF",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgILogoSmall);
export default __webpack_public_path__ + "static/media/i-logo-small.1e30645e8171e60a39f9e653f1bb0be8.svg";
export { ForwardRef as ReactComponent };